var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicLayout',{scopedSlots:_vm._u([{key:"wrapper",fn:function(){return [_c('today')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }